import { Outlet, useLocation } from 'react-router'
import { useUIStore } from '../../stores/uiStore.js'
import { AdminSidebar } from './AdminSidebar.js'
import { AdminHeader } from './AdminHeader.js'
import styles from './AdminLayout.module.css'

const PAGE_TITLES: Record<string, string> = {
  '/admin': '대시보드',
  '/admin/users': '유저 관리',
  '/admin/history': 'AI 히스토리',
  '/admin/ai-models': 'AI 모델 설정',
  '/admin/payments': '결제 관리',
  '/admin/credit-transactions': '크레딧 트랜잭션',
  '/admin/settings': '앱 설정',
}

export function AdminLayout() {
  const { pathname } = useLocation()
  const { sidebarOpen, toggleSidebar, setSidebarOpen } = useUIStore()
  const title = PAGE_TITLES[pathname] ?? '관리자'

  return (
    <div className={styles.root}>
      <AdminSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className={styles.main}>
        <AdminHeader title={title} onToggleSidebar={toggleSidebar} />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  )
}
